/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-vars */
/* eslint-disable no-console */
/* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-props-destruction */
/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import { BUNDLE, CONFIGURABLE } from '@scandipwa/scandipwa/src/util/Product';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import { connect } from 'react-redux';

import { MixType } from 'Type/Common.type';
import { PriceType } from 'Type/ProductList';
import {
    calculateFinalPrice,
    formatPrice,
    roundPrice
} from 'Util/Price';

import ProductPrice from './ProductPrice.component';
import {
    DISPLAY_PRODUCT_PRICES_IN_CATALOG_BOTH,
    DISPLAY_PRODUCT_PRICES_IN_CATALOG_EXCL_TAX,
    DISPLAY_PRODUCT_PRICES_IN_CATALOG_INCL_TAX
} from './ProductPrice.config';

/** @namespace Pwa/Component/ProductPrice/Container/mapStateToProps */
export const mapStateToProps = (state) => ({
    displayTaxInPrice: state.ConfigReducer.priceTaxDisplay?.product_price_display_type,
    productTiers: state.ProductReducer.product.price_tiers,
    bundleProductPrice: state.ProductReducer.bundleProductPrice

});

/** @namespace Pwa/Component/ProductPrice/Container/mapDispatchToProps */
// eslint-disable-next-line no-unused-vars
export const mapDispatchToProps = (dispatch) => ({});

/**
 * Product price
 * @class ProductPrice
 * @namespace Pwa/Component/ProductPrice/Container/ProductPriceContainer */
export class ProductPriceContainer extends PureComponent {
    static propTypes = {
        isSchemaRequired: PropTypes.bool,
        price: PriceType,
        mix: MixType,
        displayTaxInPrice: PropTypes.string
    };

    static defaultProps = {
        isSchemaRequired: false,
        displayTaxInPrice: DISPLAY_PRODUCT_PRICES_IN_CATALOG_INCL_TAX,
        mix: {},
        price: {}
    };

    containerProps = () => {
        const {
            price: {
                minimum_price: {
                    discount: {
                        percent_off: discountPercentage
                    } = {},
                    final_price: {
                        value: minimalPriceValue,
                        currency: priceCurrency
                    } = {},
                    regular_price: {
                        value: regularPriceValue
                    } = {}
                } = {}
            } = {},
            type_id
        } = this.props;

        if (type_id === 'amgiftcard') {
            if (!minimalPriceValue) {
                return {};
            }
        } else if (type_id !== BUNDLE && (!minimalPriceValue || !regularPriceValue)) {
            return {};
        }

        const roundedRegularPrice = this.getRoundedRegularPrice();
        const formattedFinalPrice = this.getFormattedFinalPrice();
        const formattedSubPrice = this.getFormattedSubPrice();

        return {
            roundedRegularPrice,
            priceCurrency,
            discountPercentage,
            formattedFinalPrice,
            formattedSubPrice
        };
    };

    getRoundedRegularPrice() {
        const {
            price: {
                minimum_price: {
                    regular_price: {
                        value: regularPriceValue
                    } = {},
                    regular_price_excl_tax: {
                        value: regularPriceExclTaxValue,
                        currency: priceCurrency
                    } = {}
                } = {}
            } = {},
            displayTaxInPrice
        } = this.props;

        if (displayTaxInPrice === DISPLAY_PRODUCT_PRICES_IN_CATALOG_EXCL_TAX) {
            return formatPrice(regularPriceExclTaxValue, priceCurrency);
        }

        return formatPrice(regularPriceValue, priceCurrency);
    }

    getFormattedFinalPrice() {
        const {
            price: {
                maximum_price: {
                    discount: {
                        percent_off: discountPercentage
                    } = {},
                    // final_price: {
                    default_final_price: {
                        value: minimalPriceValue,
                        currency: priceCurrency
                    } = {},
                    default_final_price_excl_tax: {
                        value: defaultFinalPriceExclTaxValue,
                        currency: priceCurrencyExclTax
                    } = {},
                    final_price_excl_tax: {
                        value: minimalPriceExclTaxValue
                    } = {},
                    final_price: {
                        value: finalPriceValue
                    } = {},
                    regular_price: {
                        value: regularPriceValue
                    } = {},
                    regular_price_excl_tax: {
                        value: regularPriceExclTaxValue
                    } = {},
                    baseBundlePrice = {}
                } = {}
            } = {},
            displayTaxInPrice,
            type_id,
            variants,
            configurableVariantIndex,
            productTiers
        } = this.props;

        if (Array.isArray(productTiers) && productTiers.length > 0) {
            const { final_price } = productTiers[0]; // Assuming you want the first tier
            if (final_price) {
                const { currency = '', value = 0 } = final_price; // Default value set to 0 if not defined
                return formatPrice(value, currency);
            }
        }

        if (type_id && type_id === CONFIGURABLE && variants) {
            const productOrVariant = variants[configurableVariantIndex];
            if (productOrVariant) {
                const {
                    price_range: {
                        minimum_price: {
                            final_price: {
                                value: finalPriceValue
                            } = {}
                        } = {}
                    } = {}
                } = productOrVariant;

                return formatPrice(finalPriceValue, priceCurrency);
            }
        }

        const finalPrice = calculateFinalPrice(discountPercentage, finalPriceValue, regularPriceValue);
        if (type_id === 'amgiftcard') {
            return formatPrice(finalPriceValue, priceCurrency);
        }

        if (type_id && type_id === BUNDLE) {
            // const { value = 0, currency } = baseBundlePrice;
            const {
                price_range: {
                    minimum_price: {
                        final_price: {
                            value: finalPriceValue
                        } = {}
                    } = {}
                } = {},
                bundleProductPrice
            } = this.props;

            return formatPrice(bundleProductPrice, priceCurrency);
        }

        if (displayTaxInPrice === DISPLAY_PRODUCT_PRICES_IN_CATALOG_EXCL_TAX) {
            const priceExclTaxValue = (defaultFinalPriceExclTaxValue === 0 || (discountPercentage && defaultFinalPriceExclTaxValue === regularPriceExclTaxValue))
                ? minimalPriceExclTaxValue
                : defaultFinalPriceExclTaxValue;

            const finalPrice = calculateFinalPrice(
                discountPercentage,
                priceExclTaxValue,
                regularPriceExclTaxValue
            );

            return formatPrice(finalPrice, priceCurrency);
        }

        return formatPrice(finalPrice, priceCurrency);
    }

    getFormattedSubPrice() {
        const {
            price: {
                minimum_price: {
                    discount: {
                        percent_off: discountPercentage
                    } = {},
                    final_price_excl_tax: {
                        value: minimalPriceExclTaxValue,
                        currency: priceCurrency
                    } = {},
                    regular_price_excl_tax: {
                        value: regularPriceExclTaxValue
                    } = {}
                } = {}
            } = {},
            displayTaxInPrice
        } = this.props;

        if (displayTaxInPrice === DISPLAY_PRODUCT_PRICES_IN_CATALOG_BOTH) {
            const finalPrice = calculateFinalPrice(
                discountPercentage,
                minimalPriceExclTaxValue,
                regularPriceExclTaxValue
            );

            return formatPrice(finalPrice, priceCurrency);
        }

        return null;
    }

    render() {
        return (
            <ProductPrice
              { ...this.props }
              { ...this.containerProps() }
            />
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ProductPriceContainer);
